var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdflarg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pdflarg"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29257",
    "data-name": "Rectangle 29257",
    width: 50,
    height: 50,
    transform: "translate(929 433)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_668",
    "data-name": "Mask Group 668",
    transform: "translate(-929 -433)",
    clipPath: "url(#pdflarg)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_80_",
    "data-name": "svgexport-6 (80)",
    transform: "translate(935.36 433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11539",
    "data-name": "Group 11539",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_1_15_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11578",
    "data-name": "Path 11578",
    d: "M14.383,0H31.25L45.544,14.9V43.88a6.561,6.561,0,0,1-6.555,6.567H14.383A6.563,6.563,0,0,1,7.816,43.88V6.567A6.563,6.563,0,0,1,14.383,0Z",
    transform: "translate(-7.816 0)",
    fill: "#e5252a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11538",
    "data-name": "Group 11538",
    transform: "translate(7.299 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11579",
    "data-name": "Path 11579",
    d: "M36.6,0V14.786H50.908Z",
    transform: "translate(-20.478)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.302
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11580",
    "data-name": "Path 11580",
    d: "M16.786,44.15V34.935h3.92a3.249,3.249,0,0,1,2.319.807,3.075,3.075,0,0,1,0,4.286,3.249,3.249,0,0,1-2.319.807H19.143V44.15Zm2.357-5.319h1.3a1.162,1.162,0,0,0,.819-.252.974.974,0,0,0,0-1.387,1.161,1.161,0,0,0-.819-.252h-1.3Zm5.723,5.319V34.935h3.265a5.7,5.7,0,0,1,1.815.277,4.879,4.879,0,0,1,1.538.819,3.619,3.619,0,0,1,1.084,1.437,5.7,5.7,0,0,1,0,4.147,3.619,3.619,0,0,1-1.084,1.437,4.881,4.881,0,0,1-1.538.819,5.7,5.7,0,0,1-1.815.277Zm2.307-2h.681a3.776,3.776,0,0,0,1.021-.126,3.061,3.061,0,0,0,.87-.416,1.868,1.868,0,0,0,.63-.807,3.58,3.58,0,0,0,0-2.508,1.869,1.869,0,0,0-.63-.807,3.06,3.06,0,0,0-.87-.416,3.779,3.779,0,0,0-1.021-.126h-.681Zm6.971,2V34.935H40.7v2H36.5v1.475h3.353v1.992H36.5V44.15Z",
    transform: "translate(-16.786 -6.51)",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdflarg);
export default __webpack_public_path__ + "static/media/pdflarg.55c3a26b79f2e0c4f48f551593b64a5f.svg";
export { ForwardRef as ReactComponent };